
export const AppModules = {
    CHANNEL_SETUP: {
        name: 'Channel Setup',
        subModules: [
            {
                id: 'configuration',
                name: 'Configuration',
                path: '/channel-profiles',
                tabs: [{ id: 'profile', name: 'Profile' }, { id: 'business_rules', name: 'Business Rules' }, { id: 'scoring', name: 'Scoring' }]
            },
            {
                id: 'architecture',
                name: 'Architecture',
                path: '/architecture',
                tabs: [{ id: 'program', name: 'Program' }, { id: 'grading', name: 'Grading' }, { id: 'minutage', name: 'Minutage' }]
            },
            {
                id: 'break-patterns',
                name: 'Break Patterns',
                path: '/break-patterns',
                tabs: null
            }
        ]
    },
    LIBRARY: {
        name: 'Library',
        subModules: [
            {
                id: 'programs',
                name: 'Programs',
                path: '/library/programs',
                tabs: null,
            },
            {
                id: 'interstitial',
                name: 'Interstitial',
                path: '/library/interstitial',
                tabs: null,
            }, {
                id: 'title-groups',
                name: 'Title Groups',
                path: '/title-groups',
                tabs: null
            },
            {
                id: 'title-groups',
                name: 'Title Groups',
                path: '/library/title-groups',
                tabs: null
            },
        ]
    },
    PLANNING: {
        name: 'Planning',
        subModules: [
            {
                id: 'inclusions',
                name: 'Inclusions',
                path: '/inclusion',
                tabs: [{ id: 'titles', name: 'Titles' }, { id: 'title-groups', name: 'Title Groups' }, { id: 'interstitials', name: 'Interstitials' }, { id: 'seasions', name: 'Seasons' }]
            },
            {
                id: 'exclusions',
                name: 'Exclusions',
                path: '/title-exclusions',
                tabs: null
            }
        ]
    },
    RIGHTS: {
        id: 'rights',
        name: 'Rights',
        path: '/rights',
        subModules: null,
    },
    SCHEDULES: {
        name: 'Schedules',
        subModules: [
            {
                id: 'view',
                name: 'view',
                path: '/view-schedules',
                tabs: null
            },
            {
                id: 'new',
                name: 'New',
                path: '/schedule',
                tabs: null
            },
            {
                id: 'submission',
                name: 'Submission',
                path: '/submission',
                tabs: null
            }
        ]
    },
    REPORTING: {
        name: 'Reporting',
        subModules: [
            {
                id: 'notifications',
                name: 'Notifications',
                path: '/notifications',
                tabs: null
            },
        ]
    },
    SETTINGS: {
        name: 'Settings',
        subModules: [
            {
                id: 'users',
                name: 'Users',
                path: '/users',
                tabs: null
            },
        ]
    },

}

export const SuperAdminModules = {
    ORGANISATIONS:
    {
        name: 'Organisations',
        path: '/organisation',
        subModules: null
    },
    USERS:
    {
        name: 'Users',
        path: '/users',
        subModules: null,
    },
    CHANNEL_GROUPS:
    {
        name: 'Channel Groups',
        path: '/channel-groups',
        subModules: null,
    },
    CHANNELS:
    {
        name: 'Channels',
        path: '/channels',
        subModules: null,
    },
    BUSINESS_RULES: 
    {
        name: 'Business Rules',
        subModules: [
            {
                id: 'business-rules',
                name: 'Business Rules',
                path: 'business-rules',
                tab: null,
            }, 
            {
                id: 'custom-business-rules',
                name: 'Custom Business Rules',
                path: 'custom-business-rules',
                tab: null,
            }
        ],
    },
    BUSINESS_RULES_V2: {
        name: 'Business Rule v2',
        subModules: [
            {
                id: 'definitions',
                name: 'Definitions',
                path: 'business-rule-definitions',
                tab: null,
            },
            {
                id: 'values',
                name: 'Values',
                path: 'business-rule-values',
                tab: null,
            },
        ],
    },
    REPORT: {
        name: 'Report',
        subModules: [
            {
                id: 'configurations',
                name: 'Configurations',
                path: '/report/configurations',
                tab: null,
            },
            {
                id: 'history',
                name: 'History',
                path: '/report/history',
                tab: null,
            },
        ],
    },
    SETTINGS:
    {
        name: 'Settings',
        subModules: [{
            id: 'email-triggers',
            name: 'Email Triggers',
            path: '/email-triggers',
            tab: null,
        }]
    },
}